import styled from "styled-components";
import { Form } from "formik";

export const Container = styled.div`
  margin-top: 20px;
  h1 {
    margin-bottom: 20px;
  }
`;

export const Text = styled.p`
  color: #5e5e5e;
  font-size: 0.9375rem;
  font-weight: 400;
  margin-bottom: 20px;
`;

export const FormContainer = styled(Form)`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const FieldContainer = styled.div`
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
